var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 3.15809C1.16669 2.34879 1.16669 1.94414 1.33543 1.72108C1.48243 1.52675 1.70712 1.4065 1.95035 1.39198C2.22955 1.37531 2.56624 1.59977 3.23962 2.04869L12.0026 7.89067C12.559 8.2616 12.8372 8.44707 12.9341 8.68084C13.0189 8.88522 13.0189 9.11491 12.9341 9.31929C12.8372 9.55306 12.559 9.73853 12.0026 10.1095L3.23962 15.9514C2.56624 16.4004 2.22955 16.6248 1.95035 16.6082C1.70712 16.5936 1.48243 16.4734 1.33543 16.2791C1.16669 16.056 1.16669 15.6513 1.16669 14.842V3.15809Z",
    stroke: "#2460B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6cf8dfdf7760aba3051902e89a01845e.svg";
export { ForwardRef as ReactComponent };